import { createContext, useContext } from 'react';

import {
  HoldingAvailability,
  HoldingAvailabilityStatus,
} from '@app/components';

export interface SummaryAvailability {
  status: HoldingAvailabilityStatus;
  isRequestable: boolean;
  isRTACApplicable: boolean;
  hasVolumes: boolean;
  hasItems?: boolean;
  copiesRemaining?: {
    available: number;
    total: number;
  };
}

export interface RecordAvailability {
  availabilityData: HoldingAvailability[];
  summaryAvailability: SummaryAvailability;
}

export interface AvailabilityContextProps {
  isAvailabilityLoading: boolean;
  availability: Record<string, RecordAvailability>;
  getAvailability: (id: string | string[], pageNumber?: number) => void;
}

export const AvailabilityContext = createContext<AvailabilityContextProps>(
  null!
);

export const useAvailabilityContext = (): AvailabilityContextProps =>
  useContext(AvailabilityContext);
